module.exports = __webpack_public_path__ + "static/pink2-2dab1920a090bfe2fc2aed7cf607af63.png";